"use strict";

import { logCookiedockError } from "~/helpers";
import { fetchInstance, type Config } from "~/services/fetch";

const baseURL = import.meta.env.VITE_BACKEND_URL;

const instance = fetchInstance.instanciate({ baseURL });

instance.interceptors.response(async (response) => {
  // Clone the response to avoid consuming the body
  const clonedResponse = response.clone();

  try {
    const data = await clonedResponse.json();
    logCookiedockError(data?.message, data?.link || import.meta.env.VITE_SUPPORT_URL || "https://cookiedock.com");
  } catch (error) {
    // If JSON parsing fails, just log a generic error
    console.warn("Failed to parse response for error logging:", error);
  }

  return response;
});

export const api = {
  get: <T>(url: string, ...config: Config[]): Promise<T> => instance.create<T>("GET", url, ...config),
  post: <T>(url: string, ...config: Config[]): Promise<T> => instance.create<T>("POST", url, ...config),
  patch: <T>(url: string, ...config: Config[]): Promise<T> => instance.create<T>("PATCH", url, ...config),
  put: <T>(url: string, ...config: Config[]): Promise<T> => instance.create<T>("PUT", url, ...config),
  delete: <T>(url: string, ...config: Config[]): Promise<T> => instance.create<T>("DELETE", url, ...config),
};
